import { render, staticRenderFns } from "./HealthLeadMediaalphaForm.vue?vue&type=template&id=109732df&"
import script from "./HealthLeadMediaalphaForm.vue?vue&type=script&lang=js&"
export * from "./HealthLeadMediaalphaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports